import { render, staticRenderFns } from "./SchoolRegistration.vue?vue&type=template&id=b13227ce&scoped=true"
import script from "./SchoolRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolRegistration.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13227ce",
  null
  
)

export default component.exports